<script setup lang="ts">
import { type Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'

import { useOwnershipDataQuery } from '~~/src/composables/query/elementals/useOwnershipDataQuery'
import { useSidebarStore } from '~~/src/stores/sidebar'

const props = defineProps<{
  elemental: Elemental
  isJson?: boolean
  isTable?: boolean
}>()

const { goToExport } = useSidebarStore()

const { data: ownershipData, isLoading: isLoadingOwnershipData } = useOwnershipDataQuery({
  id: props.elemental?.id,
  type: props.elemental.isList ? ElementalTypeEnum.List : props.elemental.elementalTypeId!,
}, {
  enabled: props.elemental.isPremium,
})

const user = useUser()
const isOwner = computed(() => user.value?.id === props.elemental.user.id)
const handlerGetKnowledgeBase = async () => {
  goToExport(
    {
      ...props.elemental,
      elemental_type_id: props.elemental.isList ? ElementalTypeEnum.List : props.elemental.elementalTypeId!,
    },
  )
}
</script>

<template>
  <MenuItem :disabled="elemental.isPremium && (isLoadingOwnershipData || (!ownershipData?.isBought && !isOwner))" @click="handlerGetKnowledgeBase">
    <template #icon>
      <div class="i-material-symbols:download-rounded w-6 h-6 " />
    </template>
    Download Knowledge Base
  </MenuItem>
</template>
